var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar", class: _vm.slideClass },
    [_c("NavbarRight")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }